module.exports = __webpack_public_path__ + "img/bet_amount_icon.1a978fc2.svg";